import React from 'react';
import PropTypes from 'prop-types';
import { Container, Content, Title } from './styled';

const Toast = ({ title, type, content = '', children }) => {
  return (
    <Container>
      <Title type={type}>{title}</Title>
      <Content>{content || children}</Content>
    </Container>
  );
};
Toast.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string
};

export default Toast;
